import React from 'react'
import Banner from './Banner'
import ApplyLoan from './ApplyLoan'
// import EmiCalculator from './EmiCalculator'
import LoanContent from './LoanContent'
// import Feature from '../Home/Feature'
import { useLocation } from 'react-router-dom'
import LoanTable from './LoanTable'
import ComparisionCard from '../ComparisionCard'

export default function Loan() {
  const location = useLocation()
  const state = location.state;

  return (
    <main>
        <Banner data={state}/>
        <ApplyLoan  data={state} />
<ComparisionCard data={state}/>
        <LoanTable data={state}/>
   
    </main>
  )
}
